import { Icon } from "./Icon";
import type { Toast as ToastT } from "../store/toast";

interface Props {
  toast: ToastT | null;
}

export function Toast({ toast }: Props) {
  return (
    <div
      className={`toast ${toast ? "is-show" : ""} ${toast?.kind ? `toast--${toast.kind}` : ""}`}
      role="status"
      aria-live="polite"
    >
      {toast?.kind === "warn" ? <Icon.Lock width={13} height={13} /> : <Icon.Check width={13} height={13} />}
      <span>{toast?.msg}</span>
    </div>
  );
}
